module.exports = __webpack_public_path__ + "img/not-accept-registration-th.d0bc525.png";